import { Component,OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialog,MdDialogRef } from '@angular/material';
import { HttpService } from '../../app/shared/services/http.service';

@Component({
    template: require('./dialog.component.html')
})
export class DialogComponent implements OnInit {
    public msg:any;
    public isConfirm: boolean  = false;
    constructor(public dialog: MdDialog,public dialogRef: MdDialogRef<DialogComponent>) {}

    ngOnInit() {
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./registrationDialog.component.html')
})
export class RegistrationDialogComponent implements OnInit {
    public msg:any;
    public isConfirm:boolean  = false;
    constructor(public dialog: MdDialog,public dialogRef: MdDialogRef<DialogComponent>) {}

    ngOnInit() {
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./applicationRejectActionDialog.component.html')
})
export class ApplicationRejectActionDialogComponent implements OnInit {

    public msg:any;
    RejectActionForm: FormGroup;
    public reasonDeatils: any;
    public isApproved: boolean;
    public isRejected: boolean;
    constructor(public dialog: MdDialog,public dialogRef: MdDialogRef<DialogComponent>,private formBuilder: FormBuilder) {}

    buildForm() {
        this.RejectActionForm = this.formBuilder.group({
            reason: this.formBuilder.control(null, [Validators.required])
        });
        this.RejectActionForm.valueChanges.subscribe(data => {
            this.reasonDeatils = this.RejectActionForm.getRawValue();
        });
    }

    ngOnInit(): void {
        this.buildForm();
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./dashboardActionDialogComponent.html')
})
export class DashboardActionDialogComponent implements OnInit {
    public msg:any;
    ActionForm: FormGroup;
    public approveDetails:any;
    public rejectDetails:any;
    public multiApproveDetails:any;
    public multiRejectDetails:any;
    public isApproved:boolean = false;
    public isReject:boolean = false;
    public multiApproveRejectFlag: boolean;
    public actionStatus: any;
    public condition1Flag: any;
    public condition2Flag: any;
    public condition3Flag: any;
    public dashboard: any;
    public row: any;
    RoleData = [
        {
            "id": 1,
            "name": "Service Partner"
        }, {
            "id": 2,
            "name": "Trade Partner"
        }
    ];

    constructor(public dialog: MdDialog,public dialogRef: MdDialogRef<DialogComponent>,private formBuilder: FormBuilder) {}

    buildForm() {
        this.ActionForm = this.formBuilder.group({
            approveGroup: this.formBuilder.group({
                /*role: this.formBuilder.control(null, [Validators.required]),*/
                selectedPartnerType: this.formBuilder.control(null, [Validators.required]),
                customerNumber: this.formBuilder.control(this.row['customerNumber'] ? this.row['customerNumber']: null, [Validators.required])
            }),
            rejectGroup: this.formBuilder.group({
                reason: this.formBuilder.control(null, [Validators.required]),
            }),
            multiApproveGroup: this.formBuilder.group({
                /*role: this.formBuilder.control(null, [Validators.required]),*/
                selectedRadioValue: this.formBuilder.control(null, [Validators.required])
            }),
            multiRejectGroup: this.formBuilder.group({
                reason: this.formBuilder.control(null, [Validators.required]),
                selectedRadioValue: this.formBuilder.control(null, [Validators.required])
            })
        });
        this.ActionForm.valueChanges.subscribe(data => {
            let actionFormDetails = this.ActionForm.getRawValue();
            this.approveDetails =  actionFormDetails.approveGroup;
            this.approveDetails['roleId'] = [];
            this.approveDetails['roleId'].push(this.approveDetails['role']);

            this.rejectDetails =  actionFormDetails.rejectGroup;
            this.multiApproveDetails = actionFormDetails.multiApproveGroup;
            this.multiApproveDetails['roleId'] = [];
            this.multiApproveDetails['roleId'].push(this.multiApproveDetails['role']);

            this.multiRejectDetails = actionFormDetails.multiRejectGroup;

            if(this.condition3Flag){
                this.multiApproveDetails['selectedRadioValue'] = "Approve All";
                this.multiRejectDetails['selectedRadioValue'] = "Approve All";
            }
        });
    }

    ngOnInit(): void {
        this.buildForm();

        if(!this.row['customerNumberMandatory']){
            this.ActionForm.get('approveGroup').get('selectedPartnerType').setValidators(null);
            this.ActionForm.get('approveGroup').get('selectedPartnerType').updateValueAndValidity();
            this.ActionForm.get('approveGroup').get('customerNumber').setValidators(null);
            this.ActionForm.get('approveGroup').get('customerNumber').updateValueAndValidity();
        }

        if(this.condition2Flag != true){
            this.ActionForm.get('multiApproveGroup').get('selectedRadioValue').setValidators(null);
            this.ActionForm.get('multiApproveGroup').get('selectedRadioValue').updateValueAndValidity();
            this.ActionForm.get('multiRejectGroup').get('selectedRadioValue').setValidators(null);
            this.ActionForm.get('multiRejectGroup').get('selectedRadioValue').updateValueAndValidity();
        }
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./applicationDashboardActionDialogComponent.html')
})
export class ApplicationDashboardActionDialogComponent implements OnInit {
    public msg:any;
    ActionForm: FormGroup;
    public multiApproveDetails:any;
    public multiRejectDetails:any;
    public isApproved:boolean = false;
    public isReject:boolean = false;
    public actionStatus: any;
    public condition1Flag: any;
    public condition2Flag: any;
    public condition3Flag: any;
    public dashboard: any;
    public row: any;
    public roles: any;
    public settings: any;

    constructor(public dialog: MdDialog,public dialogRef: MdDialogRef<DialogComponent>,private formBuilder: FormBuilder) {}

    buildForm() {
        this.ActionForm = this.formBuilder.group({
            multiApproveGroup: this.formBuilder.group({
                role: this.formBuilder.control(null, [Validators.required]),
                selectedRadioValue: this.formBuilder.control(null, [Validators.required]),
            }),
            multiRejectGroup: this.formBuilder.group({
                reason: this.formBuilder.control(null, [Validators.required]),
                selectedRadioValue: this.formBuilder.control(null, [Validators.required]),
            })
        });
        this.ActionForm.valueChanges.subscribe(data => {
            let actionFormDetails = this.ActionForm.getRawValue();

            this.multiApproveDetails = actionFormDetails.multiApproveGroup;
            this.multiApproveDetails['selectedRoles'] = [];
            for (let d in this.multiApproveDetails.role){
                this.multiApproveDetails['selectedRoles'].push(this.multiApproveDetails.role[d]['id']);
            }

            this.multiRejectDetails = actionFormDetails.multiRejectGroup;

            if(this.condition3Flag){
                this.multiApproveDetails['selectedRadioValue'] = "Approve All";
                this.multiRejectDetails['selectedRadioValue'] = "Approve All";
            }
        });
    }

    ngOnInit(): void {
        this.buildForm();
        if(this.condition2Flag != true){
            this.ActionForm.get('multiApproveGroup').get('selectedRadioValue').setValidators(null);
            this.ActionForm.get('multiApproveGroup').get('selectedRadioValue').updateValueAndValidity();
            this.ActionForm.get('multiRejectGroup').get('selectedRadioValue').setValidators(null);
            this.ActionForm.get('multiRejectGroup').get('selectedRadioValue').updateValueAndValidity();
        }
    }

    public closeDialog(){
        this.dialog.closeAll();
    }
}


@Component({
    template: require('./activeInactiveDialog.component.html')
})
export class ActiveInactiveDialogComponent implements OnInit {
    public activeDeactive: any;
    public msg:any;
    public note: any;
    public systemSetting: any;
    public isConfirm:boolean  = false;
    constructor(public dialog: MdDialog,public dialogRef: MdDialogRef<DialogComponent>) {}

    ngOnInit() {
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./csvErrorDialog.component.html')
})
export class CSVErrorDialogComponent implements OnInit {
    public msg:any;
    constructor(public dialog: MdDialog,public dialogRef: MdDialogRef<DialogComponent>) {}

    ngOnInit() {
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./showApplicationDialog.component.html')
})
export class ShowApplicationsDialogComponent implements OnInit {
    public apps:any;
    public profileFlag:any;
    constructor(public dialog: MdDialog,public dialogRef: MdDialogRef<DialogComponent>) {}

    ngOnInit() {}
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./selectApplicationDialog.component.html')
})
export class SelectApplicationsDialogComponent implements OnInit {
    ApplicationsForm: FormGroup;
    ApplicationsFormDetails: any;
    public settings = {};
    applications: any;
    applicationFlag: boolean;
    businessUnitId: any;

    constructor(public dialog: MdDialog,public dialogRef: MdDialogRef<DialogComponent>,private formBuilder: FormBuilder) {
        this.buildForm();
    }

    buildForm() {
        this.ApplicationsForm = this.formBuilder.group({
            applicationsData: this.formBuilder.control(null, [Validators.required])
        });

        this.ApplicationsForm.valueChanges.subscribe(data => {
            this.ApplicationsFormDetails = this.ApplicationsForm.getRawValue();
            this.ApplicationsFormDetails['businessUnitId'] = this.businessUnitId;

            this.ApplicationsFormDetails['applicationId'] = [];
            for (let d in this.ApplicationsFormDetails.applicationsData) {
                this.ApplicationsFormDetails['applicationId'].push(this.ApplicationsFormDetails.applicationsData[d]['id']);
            }
            this.ApplicationsFormDetails.validate = this.ApplicationsForm.valid;
        });

        this.ApplicationsForm.get('applicationsData').valueChanges.subscribe(data=> {
            if(data != null && data.length > 0){
                this.applicationFlag = false;
            } else {
                this.applicationFlag = true;
            }
        });
    }

    ngOnInit() {
        this.settings = {
            singleSelection: false,
            text:"Select Application",
            labelKey: "name",
            selectAllText:'Select All',
            unSelectAllText:'UnSelect All',
            classes:"myclass custom-class"
        };
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

@Component({
    template: require('./welcomeDialog.component.html')
})
export class WelcomeDialogComponent implements OnInit {
    public msg:any;
    constructor(public dialog: MdDialog,public dialogRef: MdDialogRef<DialogComponent>) {}

    ngOnInit() {
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
}

// Bu Assignment Dialog.

@Component({
    template: require('./buAssignmentDialog.component.html')
})
export class BuAssignmentDialogComponent implements OnInit {
    public admins: any;
    public msg:any;
    public managerName:any;
    public isConfirm: boolean = false;
    public selectedAdmin;
    public selectedAdminData;
    constructor(public dialog: MdDialog,public dialogRef: MdDialogRef<BuAssignmentDialogComponent>) {}

   
    ngOnInit() {
    }
    public closeDialog(){
        this.dialog.closeAll();
    }
    onChange(admin){
        this.isConfirm = true;
        this.selectedAdminData = admin;
    }
    closeBtn: boolean = false;
    dialogClose(result){
       this.closeBtn =  result;
    }
    ngOnDestroy(): void{
        if(!this.closeBtn){
        this.dialogRef.close(this.selectedAdminData);
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dialog/dialog.component.ts